module.exports = __webpack_public_path__ + "svg_80x80/apple.56b77a.svg";